export const AndroidFlavors = {
    FireOs: 'fireos',
    Unknown: 'unknown',
} as const;
export type AndroidFlavors = typeof AndroidFlavors[keyof typeof AndroidFlavors];

export type AndroidFlavor = {
    name: string;
    hardwareIdPrefix: string;
};

const fireOsFlavor: AndroidFlavor = {
    name: 'Amazon Fire OS',
    hardwareIdPrefix: 'Amazon',
};

const unknownFlavor: AndroidFlavor = {
    name: 'Unknown Android',
    hardwareIdPrefix: 'Android',
};

export const androidFlavorImplementations = {
    [AndroidFlavors.FireOs]: fireOsFlavor,
    [AndroidFlavors.Unknown]: unknownFlavor,
} as const;
